import { useState } from "react";
import ReportUI from "./ReportUI";
import { useForm } from "react-hook-form";
import { IDates, IIndicators, IProductReport, ITransactionReport } from "src/types/global";
import { reportService } from "@services/reportService";
import ExcelJS from "exceljs";
import { getCurrency } from "@utils/utils";
const Report = () => {
  const [isLoading, setIsLoading] = useState(false);
  const {
    handleSubmit,
    control
  } = useForm<IDates>({});
  const makeResumen = (workbook: ExcelJS.Workbook, indicators: IIndicators) => {
    workbook.addWorksheet("Resumen");
    const resumenSheet = workbook.getWorksheet("Resumen");
    if (!resumenSheet) throw new Error();
    resumenSheet.properties.defaultColWidth = 34;
    const rows = [["Saldo en cartera", getCurrency(indicators.totalRequestSum)], ["Saldo abonado", getCurrency(indicators.totalPaidSum)], ["Saldo en devoluciones", getCurrency(indicators.totalReturnSum)]];
    resumenSheet.addRows(rows);
    resumenSheet.eachRow(row => {
      row.eachCell((cell, idx) => {
        cell.border = {
          top: {
            style: "thin"
          },
          left: {
            style: "thin"
          },
          bottom: {
            style: "thin"
          },
          right: {
            style: "thin"
          }
        };
        cell.font = {
          size: 16
        };
        if (idx === 1) {
          cell.fill = {
            type: "gradient",
            gradient: "path",
            center: {
              left: 0.5,
              top: 0.5
            },
            stops: [{
              position: 0,
              color: {
                argb: "e75f11"
              }
            }, {
              position: 1,
              color: {
                argb: "ff995f"
              }
            }]
          };
          cell.font = {
            size: 16,
            color: {
              argb: "ffffff"
            }
          };
        }
      });
    });
  };
  const makeTransactions = (workbook: ExcelJS.Workbook, transactions: ITransactionReport[]) => {
    workbook.addWorksheet("Movimientos");
    const transactionsSheet = workbook.getWorksheet("Movimientos");
    if (!transactionsSheet) throw new Error();
    transactionsSheet.properties.defaultColWidth = 30;
    transactionsSheet.getRow(1).alignment = {
      horizontal: "center"
    };
    transactionsSheet.getRow(1);
    transactionsSheet.columns = [{
      header: "Responsable",
      key: "user"
    }, {
      header: "Documento de identidad",
      key: "identification"
    }, {
      header: "Cliente",
      key: "client"
    }, {
      header: "Precio total",
      key: "totalPaid"
    }, {
      header: "Fecha",
      key: "creationTime",
      width: 50
    }];
    transactionsSheet.addRows(transactions);
    transactionsSheet.eachRow((row, idx) => {
      row.eachCell(cell => {
        cell.border = {
          top: {
            style: "thin"
          },
          left: {
            style: "thin"
          },
          bottom: {
            style: "thin"
          },
          right: {
            style: "thin"
          }
        };
        cell.font = {
          size: 14
        };
        if (idx === 1) {
          cell.fill = {
            type: "gradient",
            gradient: "path",
            center: {
              left: 0.5,
              top: 0.5
            },
            stops: [{
              position: 0,
              color: {
                argb: "e75f11"
              }
            }, {
              position: 1,
              color: {
                argb: "ff995f"
              }
            }]
          };
          cell.font = {
            size: 14,
            color: {
              argb: "ffffff"
            }
          };
        }
      });
    });
  };
  const makeProducts = (workbook: ExcelJS.Workbook, products: IProductReport[]) => {
    workbook.addWorksheet("Productos solicitados");
    const productsSheet = workbook.getWorksheet("Productos solicitados");
    if (!productsSheet) throw new Error();
    productsSheet.properties.defaultColWidth = 30;
    productsSheet.getRow(1).alignment = {
      horizontal: "center"
    };
    productsSheet.getRow(1);
    productsSheet.columns = [{
      header: "Cliente",
      key: "client"
    }, {
      header: "Referencia",
      key: "productReference"
    }, {
      header: "Producto",
      key: "productName"
    }, {
      header: "Cantidad",
      key: "quantity"
    }, {
      header: "Precio total",
      key: "totalPrice"
    }];
    productsSheet.addRows(products);
    productsSheet.eachRow((row, idx) => {
      row.eachCell(cell => {
        cell.border = {
          top: {
            style: "thin"
          },
          left: {
            style: "thin"
          },
          bottom: {
            style: "thin"
          },
          right: {
            style: "thin"
          }
        };
        cell.font = {
          size: 14
        };
        if (idx === 1) {
          cell.fill = {
            type: "gradient",
            gradient: "path",
            center: {
              left: 0.5,
              top: 0.5
            },
            stops: [{
              position: 0,
              color: {
                argb: "e75f11"
              }
            }, {
              position: 1,
              color: {
                argb: "ff995f"
              }
            }]
          };
          cell.font = {
            size: 14,
            color: {
              argb: "ffffff"
            }
          };
        }
      });
    });
  };
  const makeReturns = (workbook: ExcelJS.Workbook, products: IProductReport[]) => {
    workbook.addWorksheet("Productos devueltos");
    const productsSheet = workbook.getWorksheet("Productos devueltos");
    if (!productsSheet) throw new Error();
    productsSheet.properties.defaultColWidth = 30;
    productsSheet.getRow(1).alignment = {
      horizontal: "center"
    };
    productsSheet.getRow(1);
    productsSheet.columns = [{
      header: "Cliente",
      key: "client"
    }, {
      header: "Referencia",
      key: "productReference"
    }, {
      header: "Producto",
      key: "productName"
    }, {
      header: "Cantidad",
      key: "quantity"
    }, {
      header: "Precio total",
      key: "totalPrice"
    }];
    productsSheet.addRows(products);
    productsSheet.eachRow((row, idx) => {
      row.eachCell(cell => {
        cell.border = {
          top: {
            style: "thin"
          },
          left: {
            style: "thin"
          },
          bottom: {
            style: "thin"
          },
          right: {
            style: "thin"
          }
        };
        cell.font = {
          size: 14
        };
        if (idx === 1) {
          cell.fill = {
            type: "gradient",
            gradient: "path",
            center: {
              left: 0.5,
              top: 0.5
            },
            stops: [{
              position: 0,
              color: {
                argb: "e75f11"
              }
            }, {
              position: 1,
              color: {
                argb: "ff995f"
              }
            }]
          };
          cell.font = {
            size: 14,
            color: {
              argb: "ffffff"
            }
          };
        }
      });
    });
  };
  const generateReport = async (dates: IDates) => {
    try {
      setIsLoading(true);
      const startDate = dates.startDate.format("YYYY-MM-DD");
      const endDate = dates.endDate.format("YYYY-MM-DD");
      const indicators = (await reportService.getIndicators(startDate, endDate)).data;
      const reports = (await reportService.getDetailReport(startDate, endDate)).data;
      const workbook = new ExcelJS.Workbook();
      makeResumen(workbook, indicators);
      makeTransactions(workbook, reports.transactions);
      makeProducts(workbook, reports.requestProducts);
      makeReturns(workbook, reports.returnProducts);
      workbook.xlsx.writeBuffer().then(data => {
        const blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement("a");
        anchor.href = url;
        const localStartDate = dates.startDate.format("DD-MM-YYYY");
        const localEndDate = dates.endDate.format("DD-MM-YYYY");
        anchor.download = `reporte_${localStartDate}_${localEndDate}.xlsx`;
        anchor.click();
        window.URL.revokeObjectURL(url);
      });
    } catch (error) {} finally {
      setIsLoading(false);
    }
  };
  return <ReportUI isLoading={isLoading} control={control} onSubmit={handleSubmit(generateReport)} />;
};
export default Report;